import {
  HomeIcon,
  ScaleIcon,
  ArchiveIcon,
  LibraryIcon,
  CurrencyEuroIcon,
  ClockIcon,
  CalendarIcon,
  ClipboardListIcon,
  ChartBarIcon,
} from "@heroicons/react/outline";

// Primary navigation for the desktop sidebar (same destinations as Header).
export const NAV_ITEMS = [
  { to: "/", label: "Αρχική", icon: HomeIcon, match: (p) => p === "/" },
  {
    to: "/astika",
    label: "Αστικά",
    icon: ScaleIcon,
    match: (p) => p === "/astika" || p.startsWith("/cases/"),
  },
  {
    to: "/out",
    label: "Αστικά (Εκτός Σόλων)",
    icon: ArchiveIcon,
    match: (p) => p === "/out" || p.startsWith("/outsolon/"),
  },
  {
    to: "/adjustice",
    label: "Διοικητικά",
    icon: LibraryIcon,
    match: (p) => p.startsWith("/adjustice"),
  },
  {
    to: "/eauction",
    label: "Eauction",
    icon: CurrencyEuroIcon,
    match: (p) => p.startsWith("/eauction"),
  },
  {
    to: "/prothesmies",
    label: "Προθεσμίες",
    icon: ClockIcon,
    match: (p) => p.startsWith("/prothesmies"),
  },
  {
    to: "/calendar",
    label: "Ημερολόγιο",
    icon: CalendarIcon,
    match: (p) => p === "/calendar",
  },
  {
    to: "/poinika",
    label: "Πιν.Ποινικών",
    icon: ClipboardListIcon,
    match: (p) => p.startsWith("/poinika"),
  },
  {
    to: "/case-stats",
    label: "Στατιστικά",
    icon: ChartBarIcon,
    match: (p) => p === "/case-stats",
  },
];

// Routes that render their own full-height desktop layout (panes that
// scroll internally). Every other route renders in the legacy column.
export const DESKTOP_NATIVE_ROUTES = ["/astika", "/imerologio", "/dashboard"];
